import { memo, useCallback, useState } from 'react';
import { useTranslation } from 'react-i18next';

import { CloseOutlined, FilterOutlined } from '@ant-design/icons';
import { Drawer } from 'antd';

import { useAppDispatch } from '@/shared/lib/store';
import { Button } from '@/shared/ui/button';

import { countActiveFilters } from '../../lib/active-filters-count';
import { usePatternFilterValues } from '../../model/selectors/pattern-filter';
import { clearFilter } from '../../model/slices/pattern-filter.slice';
import { PatternFilterForm } from '../pattern-filter-form/pattern-filter-form';

import cls from './pattern-filter-as-drawer.module.css';

export const PatternFilterAsDrawer = memo(() => {
    const { t } = useTranslation('pattern');
    const dispatch = useAppDispatch();
    const [isOpen, setIsOpen] = useState(false);
    const filterValues = usePatternFilterValues();
    const [resetKey, setResetKey] = useState(0);

    const activeFiltersCount = countActiveFilters(filterValues.filters);

    const handleResetFilters = useCallback(() => {
        dispatch(clearFilter());
        // Increment resetKey to force PatternFilterForm to reset
        setResetKey((prev) => prev + 1);
    }, [dispatch]);

    return (
        <>
            <div className={cls.container}>
                {activeFiltersCount > 0 && (
                    <div className={cls.filtersInfo}>
                        <span className={cls.filterCount}>
                            {t('filters.active', { count: activeFiltersCount })}
                        </span>
                        <Button
                            className={cls.resetButton}
                            icon={<CloseOutlined />}
                            onClick={handleResetFilters}
                            variant="ghost"
                        />
                    </div>
                )}

                <Button
                    icon={<FilterOutlined />}
                    onClick={() => setIsOpen(true)}
                    title={t('filter')}
                />
            </div>

            <Drawer
                closeIcon={null}
                height="90vh"
                onClose={() => setIsOpen(false)}
                open={isOpen}
                placement="bottom"
                rootClassName={cls.root}
                title={t('filter')}
            >
                <PatternFilterForm
                    afterSubmit={() => setIsOpen(false)}
                    resetKey={resetKey}
                />
            </Drawer>
        </>
    );
});

PatternFilterAsDrawer.displayName = 'PatternFilterAsDrawer';
